import { useSyncExternalStore } from 'react';

/**
 * Whether the workshop's screen window is open. One window for the whole app (`WorkshopScreenHost`,
 * mounted by AdminLayout), so it stays open — and its live session with it — from page to page until
 * it is closed; the header's button, the Bureau sidebar's button and the small Otto's « Voir son
 * écran » all drive it here.
 */
const listeners = new Set<() => void>();
let open = false;

function set(next: boolean) {
  if (open === next) return;
  open = next;
  listeners.forEach((notify) => notify());
}

export const openWorkshopScreen = (): void => set(true);
export const closeWorkshopScreen = (): void => set(false);
export const toggleWorkshopScreen = (): void => set(!open);

export function useWorkshopScreenOpen(): boolean {
  return useSyncExternalStore(
    (notify) => {
      listeners.add(notify);
      return () => listeners.delete(notify);
    },
    () => open,
  );
}
